module.exports = __webpack_public_path__ + "media/PrestonB2S-Giveaway.c44d5c22.mp4";